import React from "react";
import { motion } from "framer-motion";
import customisedHeroImg from '../Images/customised-hero.webp'

const CustomisedProductIntro = ({heading, desc}) => {
    return(
        <>
        <section className="customised-intro-section container">

  {/* LEFT */}
  <motion.div
    className="customised-left"
    initial={{ opacity: 0, x: -70 }}
    whileInView={{ opacity: 1, x: 0 }}
    transition={{
      duration: 0.9,
      ease: [0.22, 1, 0.36, 1],
    }}
    viewport={{ once: true, amount: 0.25 }}
  >

    {/* SUBHEADING */}
    <motion.h3
      className="section-subheading"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      viewport={{ once: true }}
    >
      CUSTOMISED SOLUTION
    </motion.h3>

    {/* HEADING */}
    <motion.h2
      className="section-heading"
      initial={{ opacity: 0, y: 35 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{
        delay: 0.15,
        duration: 0.75,
      }}
      viewport={{ once: true }}
    >
      {heading}
    </motion.h2>

    {/* TEXT */}
    <motion.p
      className="section-text"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{
        delay: 0.3,
        duration: 0.8,
      }}
      viewport={{ once: true }}
    >
     {desc}
    </motion.p>

    {/* CHECK LIST */}
    <motion.ul
      className="custom-check-list"
      variants={{
        hidden: {},
        visible: {
          transition: {
            staggerChildren: 0.12,
          },
        },
      }}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.15 }}
    >

      {[
        "Custom Sizes & Structures",
        "Suitable for Multiple Industries",
        "High-Quality Wood & Plywood",
        "ISPM-15 Heat Treatment Available",
        "Designed for Safe Transportation",
      ].map((item, i) => (
        <motion.li
          key={i}
          variants={{
            hidden: {
              opacity: 0,
              x: -25,
            },
            visible: {
              opacity: 1,
              x: 0,
            },
          }}
          transition={{
            duration: 0.55,
            ease: [0.22, 1, 0.36, 1],
          }}
          whileHover={{
            x: 6,
          }}
        >
          {item}
        </motion.li>
      ))}

    </motion.ul>

  </motion.div>

  {/* RIGHT IMAGE */}
  <motion.div
    className="customised-right"
    initial={{ opacity: 0, x: 70 }}
    whileInView={{ opacity: 1, x: 0 }}
    transition={{
      duration: 1,
      ease: [0.22, 1, 0.36, 1],
    }}
    viewport={{ once: true, amount: 0.25 }}
  >

    <motion.img
      src={customisedHeroImg}
      alt="Packaging Built Around Your Requirements | Gurukrupa Wood Pvt. Ltd."
      initial={{
        scale: 1.08,
        opacity: 0,
      }}
      whileInView={{
        scale: 1,
        opacity: 1,
      }}
      transition={{
        duration: 1,
      }}
      viewport={{ once: true }}
      whileHover={{
        scale: 1.03,
      }}
    />

  </motion.div>

</section>
        </>
    )
}
export default CustomisedProductIntro